import { render, staticRenderFns } from "./DownloadImg.vue?vue&type=template&id=56933344&"
import script from "./DownloadImg.vue?vue&type=script&lang=js&"
export * from "./DownloadImg.vue?vue&type=script&lang=js&"
import style0 from "./DownloadImg.vue?vue&type=style&index=0&id=56933344&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports